import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SearchBarResults } from '../search-bar-results/search-bar-results';

@Component({
  selector: 'jtms-search-modal',
  imports: [MatDialogModule, SearchBarResults],
  templateUrl: './search-modal.html',
  styleUrl: './search-modal.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchModal {}
